import * as consts from './ListingsConsts';
import { getListingsRequest } from '../helpers/requestUtils';

export const getListings = () => {
    return (dispatch, getState) => {
        dispatch({
            type: consts.GET_LISTINGS_PENDING
        });
        const tourId = getState().app.tourId;
        const tourType = getState().app.tourType;
        const listingPerPage = getState().listings.listingPerPage;
        const startFrom = 0;

        return getListingsRequest(tourId, tourType, listingPerPage, 0)
            .then(response => {
                if (!!+response.data.disabled) {
                    dispatch(notFoundActions.redirectToNotFound());
                    dispatch({
                        type: consts.GET_LISTINGS_REJECTED,
                        payload: {
                            getListingsError: 'Listings are not found'
                        }
                    });
                    return;
                }
            dispatch({
                type: consts.GET_LISTINGS_FULFILLED,
                payload: response.data
            });
        }, error => {
            console.log(error);
            dispatch(notFoundActions.redirectToNotFound());
            dispatch({
                type: consts.GET_LISTINGS_REJECTED,
                payload: {
                    getListingsError: error
                }
            });
        });
    }
}


export const getListingsPagination = (tourId, tourType, listingPerPage, startFrom) => {

    return dispatch => {
        dispatch({
            type: consts.LISTINGS_PAGINATION_PENDING
        });

        return getListingsRequest(tourId, tourType, listingPerPage, startFrom)
            .then(response => {
                if (!!+response.data.disabled) {
                    dispatch({
                        type: consts.LISTINGS_PAGINATION_REJECTED,
                        payload: {
                            getListingsError: 'Listings are not found'
                        }
                    });
                    return;
                }
            dispatch({
                type: consts.LISTINGS_PAGINATION_FULFILLED,
                payload: response.data
            });
        }, error => {
            console.log(error);
            dispatch({
                type: consts.LISTINGS_PAGINATION_REJECTED,
                payload: {
                    getListingsError: error
                }
            });
        });
    }
}
